import type { BlockOpenAPISchemasData } from '@gitbook/doc-core';
import type { BlockProps } from '@gitbook/slate-react';
import { Icon } from '@gitbook/spine-icons';

import { useBlockPaletteFactory } from '../../common';
import { BlockOpenAPIFetchWrapper } from '../BlockOpenAPIFetchWrapper';
import { OpenAPISchemasBlockContent } from './OpenAPISchemas';

/**
 * Component to render a openapi-schemas block.
 */
export function BlockOpenAPISchemas(props: BlockProps) {
    const { editor, node } = props;

    const data = node.data.toFrozenObject() as BlockOpenAPISchemasData;

    const palette = useBlockPaletteFactory({
        nodeKey: node.key,
        createExtraGroups: () => [
            {
                key: 'actions',
                commands: [
                    {
                        key: 'schema-group',
                        title: `${data.grouped ? 'Ungroup' : 'Group'} schema`,
                        icon: Icon.OpenAPI,
                        trigger: () => {
                            editor.change((change) => {
                                change.setNodeByKey(node.key, {
                                    data: {
                                        ...data,
                                        grouped: !data.grouped,
                                    },
                                });
                            });
                        },
                    },
                ],
            },
        ],
    });

    return (
        <BlockOpenAPIFetchWrapper {...props} palette={palette} data={data}>
            {({ filesystem, specUrl }) => {
                return (
                    <OpenAPISchemasBlockContent
                        specUrl={specUrl}
                        filesystem={filesystem}
                        data={data}
                    />
                );
            }}
        </BlockOpenAPIFetchWrapper>
    );
}
